import { api, getWithOptionalAuthorizationGeneric } from './api';
import { CITY_BASE } from './apiConstant';
import { getToken } from './auth';
import { decryptMessage } from '../utils/decrypt';

export type CityResponse = {
  cityDataResponses: CityData[];
  fileUrl: string;
  description: string;
};

export type CityData = {
  id: string;
  name: string;
};


const cityApi = {

  getCitiesByRegionId : async (regionId: string): Promise<CityResponse> => {
    try {
      const encryptedContestResponse = await getWithOptionalAuthorizationGeneric<CityResponse[]>
            (`${CITY_BASE}/GetCities/${regionId}`, true);
      const getCityResponse = await decryptMessage(encryptedContestResponse.data.Data, getToken());
      return getCityResponse;
    } catch (error) {
      console.error('Error fetching cities by region Id:', error);
      throw error;
    }
  }
};

export default cityApi;